export default __webpack_public_path__ + "static/media/endiseno.f9a7d5a0.svg";